export default {"src":"/_next/static/media/business-transaction-icon.78cee49a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};